"use client"

import { AnimatedSection } from "./AnimatedSection"

const editionVideos = {
  chennai: {
    src: "https://www.youtube.com/embed/PrXIqi6Hyh0",
    title: "Candela Technology Summit 2026 - Chennai Edition Highlights",
    description: "Relive the day — the talks, the people, and the conversations from the Chennai Edition.",
  },
  bangalore: {
    src: "https://www.youtube.com/embed/Xs99NTyQRxQ",
    title: "Candela Technology Summit 2025 - Bangalore Edition Highlights",
    description: "Experience the cutting-edge technology and networking opportunities at the Candela Technology Summit.",
  },
  vizag: {
    src: "https://www.youtube.com/embed/2112-BiWqrA",
    title: "Candela Technology Summit 2025 - Vizag Edition Highlights",
    description: "Experience the cutting-edge technology and networking opportunities at the Candela Technology Summit.",
  },
}

export function PosterSection({ currentEdition = "bangalore" }) {
  const video = editionVideos[currentEdition] || editionVideos.bangalore

  return (
    <section className="py-20 bg-gradient-to-br from-white to-green-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <AnimatedSection>
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-green-800 mb-4">
              Event Highlights
            </h2>
            <p className="text-xl text-green-600 max-w-2xl mx-auto">{video.description}</p>
          </div>
        </AnimatedSection>

        <AnimatedSection delay={300}>
          <div className="max-w-5xl mx-auto">
            {/* Main Video Display */}
            <div className="relative group mb-8">
              <div className="relative overflow-hidden rounded-2xl shadow-2xl" style={{ paddingTop: "56.25%" }}>
                <iframe
                  src={video.src}
                  title={video.title}
                  className="absolute top-0 left-0 w-full h-full"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>

              {/* Video Title */}
              <div className="mt-4 text-center">
                <h3 className="text-2xl font-bold text-green-800 mb-2">{video.title}</h3>
              </div>
            </div>
          </div>
        </AnimatedSection>
      </div>
    </section>
  )
}